export default "__VITE_ASSET__BR6tpXjZ__"